<template>
    <main class="">
      <header class="bg-teal-500 text-white p-2 py-4 text-lg flex items-center">
          <h1 class="flex-grow text-center -mr-8">{{ formTitle | capitalize}}</h1>
          <icon-close @click.native="onCancel" size="md" class="text-teal-300 mr-2 cursor-pointer hover:text-white"></icon-close>
      </header>
      <section v-if="!log.tag">
          <ul class="text-center my-4 px-4">
              <li v-for="shortcut in shortcuts" :key="shortcut.label"><button class="bg-white text-gray-700 border border-gray-400 w-full rounded py-2 mt-2 hover:bg-gray-200 hover:text-black hover:shadow" @click="onShortcutClick(shortcut)">{{ shortcut.label }}</button></li>
          </ul>
      </section>
      <section v-if="log.tag" class="p-4 px-6 text-sm">

          <form @submit.prevent="onFormSubmit" >


              

              <div class="field flex items-center mt-4">
                  <label class="w-1/3 mr-2 uppercase text-sm" for="log_value" v-if="log.tag == 'count'">{{ log.key | capitalize }} Count:</label>
                  <label class="w-1/3 mr-2 uppercase text-sm" for="log_value" v-else-if="log.tag == 'downtime'">Duration (minutes)</label>
                  <label class="w-1/3 mr-2 uppercase text-sm" for="log_value" v-else>Amount</label>

                  <input id="log_value" class="w-1/2 border rounded px-2 py-1" name="value" type="number" v-model="log.value" :placeholder="(log.key==counterKey)?lastProductionCount:''" required>
              </div>
              <div class="flex mt-4 z-20 relative">
                  <label class="w-1/3 mr-2 mt-1 uppercase text-sm">Date and time:</label>
                  <div>
                    <date-time-picker :stacked="true" class="w-2/3" v-model="log.date" :input-attributes="{required:true}"></date-time-picker>
                  </div>
              </div>

                <div class="field flex items-center mt-4" v-if="isDowntimeLog || isLossLog">
                  <label class="w-1/3 mr-2 mt-1 uppercase text-sm">Machine</label>
                  <div class="relative">
                    <select v-model="log.code" required class="block appearance-none w-full bg-white border border-gray-200 text-gray-700 px-2 py-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option :value="null">Select Machine</option>
                        <option v-for="category in downtimeCategories" :key="category.name" :value="category.name">{{ category.name }}</option>
                        
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
              </div>

              <div class="field flex items-center mt-4" v-if="isDowntimeLog">
                  <label class="w-1/3 mr-2 mt-1 uppercase text-sm">Reason</label>
                  <div class="relative">
                    <select v-model="log.detail" required class="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-2 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option :value="null">Select Downtime Reason</option>
                        <option v-for="reason in downtimeReasons" :key="reason.name" :value="reason.name">{{ reason.name }}</option>
                        
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
              </div>

              <div class="flex mt-4">
                  <label for="count_note" class="w-1/3 mr-2 mt-1 uppercase text-sm">{{ (log.tag == "downtime")?"Solution / Fix":"Notes" }}:</label>
                  <textarea id="count_note" v-model="log.note" class="border w-auto h-16 w-2/3 ml-2 p-1"></textarea>
              </div>

              <div class="my-4 mt-8 border-t pt-4">
                <button type="submit" class='p-2 px-4 border rounded bg-orange-500 text-white mr-2'>{{ submitTitle }}</button>
                <button @click.prevent="onCancel" class='p-2 px-4 border rounded mr-2'>Cancel</button>
                <button @click.prevent="onDelete" v-if="this.record" class='p-2 px-4 border rounded bg-red-500 text-white'>Delete</button>
              </div>
          </form>

          <ul class="errors" v-if="errors">
              <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
              </li>

          </ul>

      </section>
      
  </main>
</template>

<script>

    import fecha from 'fecha'
    import DateTimePicker from '@/components/DateTimePicker.vue'

    export default {
        name: "log-form",

        components: {
            DateTimePicker
        },

        mounted: function(){

            if(this.record){
                this.setInitValues(this.record);
                return;
            }else{
                this.log.line = this.line;
            }

            if(this.shortcutId){
                let passedShortcut = this.shortcutMap[this.shortcutId];

                if(passedShortcut){
                    this.onShortcutClick(passedShortcut);
                }
            }

            
        },

        props: {
            workOrderNum:{
                type: String
            },

            line: {},
            
            record: {
                type: Object
            },

            counterKey: {
                default: "filler"
            },

            lastProductionCount: {

                default: ""
            },

            order: {
                //used to validate in general
                default: function(){
                    return null;
                }
            },

            relatedLogs: {
                //used to validate against exisiting log
                default: function(){
                    return [];
                }

            },


            shortcutId: {
                required: false,
                default: ""

            },

            shortcutOptions: {
                required: false,
                default: function(){
                    return []
                },
            }
        },

        data() {
            return {
                log: {
                    work_order: this.workOrderNum,
                    line: "",
                    tag: "",
                    key: "",
                    value: "",
                    code: null,
                    detail: null,
                    date: "",
                    note: ""
                },

                shortcut: null,

                tags: [],

                errors: null,

                downtimeCategories: []
            }
        },
        methods: {

            checkForValidationWarnings: function(){

                var warnings = [];
                if(this.relatedLogs.length){
                    let endDate = new Date(this.log.date);

                    if(this.log.detail == "end"){
                        let startLog = this.relatedLogs.find((logEntry) => {
                            return ((logEntry.code == this.log.code) && (logEntry.detail == "start"))
                        });

                        if(startLog){
                            let startDate = new Date(startLog.date);
                            if(startDate.getTime() > endDate.getTime()){
                                warnings.push(`This date and time must be AFTER the related  ${this.log.code } start time of ${startDate.toLocaleString()}. `);
                            }

                            if(parseInt(startLog.value) != parseInt(this.log.value)){
                                warnings.push(`This count value is different from the preceeding start value of ${startLog.value}. If the earlier count was incorrect, update that log value first.`);
                            }
                        }
                    }


                }

                if(warnings.length){
                    return warnings;
                }

                return;
            },


            onFormSubmit: function(){

                let validationWarnings = this.checkForValidationWarnings();

                if(validationWarnings){
                    this.errors = validationWarnings;
                    return;
                }

            console.log("Submitting Form");



            if(this.record){
                //this is an update (patch)

                var changes;
                Object.keys(this.log).forEach((key) => {
                    if(this.log[key] != this.record[key]){
                        if(!changes){
                            changes = {};
                        }
                        changes[key] = this.log[key];
                    }
                });

                if(changes){
                    this.$api.apiRequest("patch","productionlogs/"+this.record.id+"/",changes).then((response) => {
                        console.log("patch response", response);
                        this.handleErrorsOrLeave(response);
                    })
                    .catch((error) => {
                        console.log("error", error, error.response);
                        alert(error);
                    })

                }else{
                    console.log("no changes detected, will just return to work order page");
                    alert("There were no changes made to this record. Make a change before updating or click Cancel to exit.")

                }



                
            }else{
                //this is a create (post)
                this.$api.apiRequest("post","productionlogs/",this.log).then((response) => {
                    console.log("post response", response);
                    this.handleErrorsOrLeave(response);

                })
                .catch((error) => {
                    console.log("error", error, error.response);
                })

            }


            

        },

            onCancel: function(){
                this.$emit("close");
            },

            onDelete: function(){

                if(confirm("Click OK to delete this log entry. Warning... this can not be undone!")){
                    this.$api.apiRequest("delete","productionlogs/"+this.record.id+"/",this.log).then((response) => {
                    console.log("delete response", response);
                    this.handleErrorsOrLeave(response);
                    

                })
                .catch((error) => {
                    console.log("error", error, error.response);
                })
                }
                
            },

            getLogEntry() {
                
            },

            getDowntimeCodes() {

                console.log("getDowntimeCodes", this.log);
                this.$api.getRecords('downtimecategories/', { line: this.log.line })
                .then((response) => {
                    if(response.results){
                        this.downtimeCategories = response.results;
                    }
                })
            },

            onShortcutClick: function(shortcut){
                this.setInitValues(shortcut.record);
                this.shortcut = shortcut;
                if((shortcut.id == "downtime" || shortcut.id == "loss")){
                    this.getDowntimeCodes();
                }
            },

            setInitValues: function(initValues){



                this.log = { ...this.log, ...initValues }
                if(((initValues.tag == "downtime") || (initValues.tag == "loss")) && this.log.line){
                    this.getDowntimeCodes();
                }
            },

            leavePageAndUpdate: function(update){
                if(update){
                    this.$emit("update", this.log);
                }
                
                this.$emit("close");
            },

            handleErrorsOrLeave: function(response){

            
                if(response.success && response.success.status < 300){
                    this.leavePageAndUpdate(true);
                }else{
                    let validationErrors = this.checkForValidationErrors(response);

                    if(validationErrors ){
                        alert("There was a problem. Check the form and try again.");
                    }
                }
            },

            checkForValidationErrors: function(response){
                console.log("Checking for errors");
                if(response.error){
                    console.log("Error found");
                    if(response.error.response){
                        let errorResponse = response.error.response;
                        if(errorResponse.data){
                            console.log("Validation Errors", errorResponse.data);
                            this.errors = errorResponse.data;
                            return this.errors;
                        }
                    }
                }
            }

        },
        computed: {

            formTitle: function(){
                if(this.log.tag){

                    var title = "Log Entry";

                    if(this.shortcut){
                        return this.shortcut.label;
                    }

                    switch (this.log.tag){
                        case 'count':
                            if(this.log.code == "setup"){
                                title = "Setup " + ((this.log.detail == "start")?"Start":"End");
                            }else if(this.log.code == "cleaning"){
                                title = "Cleaning " + ((this.log.detail == "start")?"Start":"End");
                            }else if(this.log.code == "lunch"){
                                title = "Lunch " + ((this.log.detail == "start")?"Start":"End");
                            }else{
                                title = `${this.log.key} Count`;
                            }
                            break;

                        case 'downtime': 
                            title = "Downtime Incident"
                            break;

                        case 'note': 
                            title = "General Note"
                            break;

                        default:
                            title = "Log Entry"
                    }


                    return title;
                    
                }else{
                    return "Choose Log Entry Type"
                }
            },

            submitTitle: function(){
                if(this.record){
                    return "Update"
                }else{
                    return "Submit"
                }
            },

            isDowntimeLog: function(){
                if(this.log && (this.log.tag == "downtime")){
                    if((this.log.code != "setup") && (this.log.code != "cleaning")){
                        return true;
                    }
                }

                return false;
            },

            isLossLog: function(){
                if(this.log && (this.log.tag == "loss")){
                    return true;
                }

                return false;
            },

            downtimeReasons: function(){

                if(this.log.code){
                    let selectedCategory = this.downtimeCategories.find((category) => {
                        return category.name == this.log.code
                    })

                    if(selectedCategory){
                        return selectedCategory.reasons;
                    }
                }
                return []
            },

            shortcutMap: function(){
                return {
                    "setup:start":{
                        id:"setup:start",
                        label: "Start Setup",
                        description: "Log setup start.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "setup",
                            detail: "start",
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "setup:end":{
                        id:"setup:end",
                        label: "End Setup",
                        description: "Log setup end.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "setup",
                            detail: "end",
                            value: this.lastProductionCount,
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "cleaning:start":{
                        id:"cleaning:start",
                        label: "Start End of Batch Activities/Cleaning",
                        description: "Log cleaning start.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "cleaning",
                            detail: "start",
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "cleaning:end":{
                        id:"cleaning:end",
                        label: "Complete End of Batch Activities/Cleaning",
                        description: "Log cleaning end.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "cleaning",
                            detail: "end",
                            value: this.lastProductionCount,
                            date: this.$api.timestamp(new Date())
                        }
                    },

                    "lunch:start":{
                        id:"lunch:start",
                        label: "Start Lunch",
                        description: "Log lunch start.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "lunch",
                            detail: "start",
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "lunch:end":{
                        id:"lunch:end",
                        label: "End Lunch",
                        description: "Log lunch end.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "lunch",
                            detail: "end",
                            value: this.lastProductionCount,
                            date: this.$api.timestamp(new Date())
                        }
                    },

                    "pause:start":{
                        id:"pause:start",
                        label: "Pause Production",
                        description: "Begin scheduled downtime.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "pause",
                            detail: "start",
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "pause:end":{
                        id:"pause:end",
                        label: "Resume Production",
                        description: "End scheduled downtime.",

                        record: {
                            tag: "count",
                            key: this.counterKey,
                            code: "pause",
                            detail: "end",
                            value: this.lastProductionCount,
                            date: this.$api.timestamp(new Date())
                        }
                    },

                    "count:filler":{
                        id:"count:filler",
                        label: "Filler Count",
                        description: "Log filler count.",

                        record: {
                            tag: "count",
                            key: "filler",
                            code: null,
                            detail: null,
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "count:packer":{
                        id:"count:packer",
                        label: "Packer Count",
                        description: "Log packer count.",

                        record: {
                            tag: "count",
                            key: "packer",
                            code: null,
                            detail: null,
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "downtime":{
                        id:"downtime",
                        label: "Downtime Incident",
                        description: "Log downtime incident.",

                        record: {
                            tag: "downtime",
                            key: "duration",
                            code: null,
                            detail: null,
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    },
                    "loss":{
                        id:"loss",
                        label: "Loss Amount",
                        description: "Log loss amount.",

                        record: {
                            tag: "loss",
                            key: "amount",
                            code: null,
                            detail: null,
                            value: "",
                            date: this.$api.timestamp(new Date())
                        }
                    }

                }
            },


            shortcuts() {
                return this.shortcutOptions.map((shortcutId) => {
                    return this.shortcutMap[shortcutId];
                })
            }
        },
    }
</script>

<style scoped>

    .errors {
        color: red;
    }

</style>